import { render } from "./regesiter.vue?vue&type=template&id=593de9b0&scoped=true&ts=true"
import script from "./regesiter.vue?vue&type=script&lang=ts"
export * from "./regesiter.vue?vue&type=script&lang=ts"

import "./regesiter.vue?vue&type=style&index=0&id=593de9b0&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593de9b0"]])

export default __exports__